import { Breadcrumb } from 'antd';
import Home2OutlineIcon from 'components/AppIcon/Home2OutlineIcon';
import { Link, useLocation, useMatches } from 'react-router-dom';
import { AppUIMatch } from 'routes/types';

export default function AppBreadcrumbs() {
  const matches = useMatches() as AppUIMatch[];
  const location = useLocation();

  const isHome = location.pathname === '/';

  let crumbs = matches
    .filter(match => match.handle?.crumb != null)
    .map(match => {
      const crumbFnOrValue = match.handle?.crumb;

      const label =
        typeof crumbFnOrValue === 'function'
          ? crumbFnOrValue(match)
          : crumbFnOrValue;

      return {
        label,
        path: match.pathname,
        clickable: match.handle?.clickable !== false,
      };
    });

  if (!isHome && crumbs.length > 0 && crumbs[0]?.label !== 'Trang chủ') {
    crumbs = [
      {
        label: <Home2OutlineIcon className="h-6 w-4 text-[#5a6a78]" />,
        path: '/',
        clickable: true,
      },
      ...crumbs,
    ];
  }

  if (isHome || crumbs.length === 0) {
    return <h1 className="text-2xl font-semibold">Dashboard</h1>;
  }

  return (
    <Breadcrumb
      className="[&_ol]:list-none"
      separator={<span className="font-bold text-[#5a6a78]">/</span>}
      items={crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        const shouldLink = !isLast && crumb.clickable;

        return {
          title: shouldLink ? (
            <Link to={crumb.path}>{crumb.label}</Link>
          ) : (
            <span>{crumb.label}</span>
          ),
        };
      })}
    />
  );
}
